import React from "react";
import { CurrencyInputFieldTemplate } from "themes/common/components";

function CurrencyInputField(props) {
    return <CurrencyInputFieldTemplate {...props} />;
}

export default CurrencyInputField;
